export default "__VITE_ASSET__DmNsrdDY__"